import type { AxiosError } from 'axios'
import { useCallback, useState } from 'react'

import { useToast } from '@/hooks'
import { servicoBase } from '@/services/servico-base'

import type { MarcarNotificacaoComoVisualizadaResposta } from './tipos'

/**
 * POST /v1/notificacoes/{idDaNotificacao}/visualizar
 * → 200 OK
 */
export function useMarcarNotificacaoComoVisualizada(): MarcarNotificacaoComoVisualizadaResposta {
  const toast = useToast()

  const [loading, setLoading] = useState<boolean>(false)
  const [erro, setErro] = useState<AxiosError | null>(null)

  const marcarNotificacaoComoVisualizada = useCallback(
    async (idDaNotificacao: number): Promise<boolean> => {
      if (!idDaNotificacao) return false

      try {
        setLoading(true)

        await servicoBase.post(`/v1/notificacoes/${idDaNotificacao}/visualizar`)

        return true
      } catch (error: any) {
        setErro(error as AxiosError)

        toast.erro('Aconteceu um erro', {
          descricao: `Não foi possível marcar a notificação como vista: ${error?.response?.data?.detail ?? 'Erro desconhecido.'}`,
        })
      } finally {
        setLoading(false)
      }

      return false
    },
    []
  )

  return [marcarNotificacaoComoVisualizada, { loading, erro }]
}
